import fly from './fly';

const initialViewport = [-0.1257, 51.5224, 14.00];

const flyToInitial = (map) => {
    fly(map, initialViewport);
}

export default flyToInitial;